import { css } from 'emotion'

export const ArrowRightIconStyles = css`
  transform: rotate(180deg);
`
